import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../../api/manageServer";
import { Auth, SignUp } from "../../../@types/auth";
import toast from "react-hot-toast";
import { fetchUser } from "../user/userSlice";
import { addToCart, setIsLoggedin } from "../cart/cartSlice";
import {
  addFavorite,
  saveFavorite,
  setFavLoggedIn,
} from "../favorite/favoriteSlice";

// Define the shape of your auth state
interface AuthState {
  isLoading: boolean;
  error: string | null; // changed 'false' to 'null' for better clarity
  tokenType: string;
  auth: any;
}

const initialState: AuthState = {
  isLoading: false,
  error: null, // Set error to null initially
  tokenType: "Bearer",
  auth: null,
};

// console.log("authSlice");

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    logInSuccess(state, action: PayloadAction<any>) {
      state.isLoading = false;
      state.auth = action.payload;
      localStorage.setItem("authToken", action.payload.token);
    },

    loginFailure(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.auth = null;
    },
  },
});

export default slice.reducer;

export const { actions } = slice;

// Thunk action for login
export function AuthLogIn(
  login: Auth,
  selectedCartItem: any,
  selectedFavorite: any,
  isFavLoggedin?: boolean
) {
  return async (dispatch: any) => {
    dispatch(actions.startLoading());
    try {
      const response = await axiosInstance.post("/auth/logIn", login);
      console.log(selectedFavorite);

      if (response?.data?.success) {
        localStorage.setItem("authToken", response.data.token);
        dispatch(fetchUser(response.data.userId));
        dispatch(actions.logInSuccess(response.data));
        dispatch(setIsLoggedin(true));
        if (selectedCartItem) {
          dispatch(addToCart(selectedCartItem));
        }
        if (selectedFavorite) {
          dispatch(saveFavorite({ productId: selectedFavorite?.productId }));
        }
        console.log("🚀 ~ return ~ isFavLoggedin:", isFavLoggedin)
        if (isFavLoggedin) {
          
          dispatch(setFavLoggedIn(false));
        }
        await fetchUser(response.data.userId);
        toast.success(response?.data?.message || "Login successful");
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }
      return response.data;
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || "Login failed";
      dispatch(actions.loginFailure(errorMessage));
      toast.error(errorMessage);
    }
  };
}
export function AuthLogOut() {
  return async (dispatch: any, getState: any) => {
    try {
      const authToken = localStorage.getItem("authToken");

      const state = getState();

      const userId = state.auth?.auth?.userId;

      const response = await axiosInstance.post(
        `token/auth/logout?userId=${userId}&action=logout`
      );

      if (response?.data?.success) {
        console.log("jjjjjjjjjjjj");
        localStorage.removeItem("authToken");
        dispatch(actions.logout());

        toast.success(response?.data?.message || "Logged out successfully");
      } else {
        toast.error(response?.data?.message || "Logout failed");
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || "Failed to log out";
      toast.error(errorMessage);
    }
  };
}

export function AuthSignUp(signup: SignUp) {
  return async (dispatch: any) => {
    dispatch(actions.startLoading());
    try {
      const response = await axiosInstance.post("/user", signup);
      if (response?.data?.success) {
        dispatch(fetchUser(response.data.userId));
        const success = response.data?.message === "Registration successful";
        dispatch(setIsLoggedin(true)); // Or other condition
        dispatch(actions.logInSuccess(response.data));
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message || "Unexpected response format");
      }
      return response.data;
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || error?.message || "An error occurred";
      dispatch(actions.loginFailure(errorMessage));
      toast.error(errorMessage);
    }
  };
}

// Social Login action
export function Sociallogin(values: any) {
  return async (dispatch: any) => {
    try {
      const response = await axiosInstance.post("/auth/social-login", {
        authProvider: values.authProvider,
        token: values.token,
      });
      dispatch(actions.logInSuccess(response.data));
    } catch (error: any) {
      dispatch(actions.hasError(error.message || "Login failed"));
    }
  };
}
